export default [
    {
      title: 'Horoscope',
      customIcon: 'HoroscopedSVG',
      children: [
        {
          title: 'Horoscope Type',
          route: 'custom-module',
          path: '/custom-module/horoscoped',
        },
      ],
    },
  ];
  